export default __webpack_public_path__ + "static/media/mfukopesa.e16a8db9.png";